export default class IEcheck {

	constructor() {
		const oldbrowserCookie = this.getCookie('oldbrowser');
		const agent = window.navigator.userAgent.toLowerCase();
		if (agent.indexOf('trident') > -1) {
			if (oldbrowserCookie == '') {
				alert(
					'Je gebruikt een verouderde browser. Overweeg een modernere browser zoals Chrome, Firefox of Edge te gebruiken.',
				);
				this.setCookie('oldbrowser', true, 365);
			}
		}
	}

	getCookie(cname) {
		let name = cname + '=';
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}

	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}
}
